export default "__VITE_ASSET__7dvkrU$N__"